import { ChartsType, IStatsStore } from './index'

export default {
  chartType: 'all' as ChartsType,
  selectedRooms: [],
  year: new Date().getFullYear(),
  month: 0,
} as IStatsStore
